import UrlParse from 'url-parse';

import { getAdvCode } from './get-adv-code';

/*
 * TODO: Этот интерфейс можно было заюзать из './get-adv-code'
 * нужно часть полей переименовать и отследить где используется функция
 */
interface IAdvCodeNameLink {
    advCodeName: string;
    link: string;
}

export const getLinkWithAdvCode = ({ advCodeName, link }: IAdvCodeNameLink): string => {
    const ParsedUrl = new UrlParse(link, {}, true);

    // Если какое-то значение уже выставлено, выходим
    if (ParsedUrl.query[advCodeName]) {
        return link;
    }

    // Добавляем значение в query
    ParsedUrl.query[advCodeName] = getAdvCode({ advCodeName });

    return ParsedUrl.toString();
};
